import { Injectable } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { ClienteData } from 'src/app/data/cliente/cliente.data';

@Injectable()
export class FormService {

  stepActive?: number;
  stepSubmit?: boolean;
  modalResumo?: boolean;
  atualizarFormaPagamento?: boolean;

  statusMenu?: boolean;
  menuSelecionado?:string;

  private stepProdutoGarantia: Subject<FormGroup> = new Subject();
  formProdutoGarantia: Observable<FormGroup> = this.stepProdutoGarantia.asObservable();

  private stepObjetoGarantia: Subject<FormGroup> = new Subject();
  formObjetoGarantia: Observable<FormGroup> = this.stepObjetoGarantia.asObservable();

  private stepTitularSubscritor: Subject<FormGroup> = new Subject();
  formTitularSubscritor: Observable<FormGroup> = this.stepTitularSubscritor.asObservable();

  private stepLocatario: Subject<FormGroup> = new Subject();
  formLocatario: Observable<FormGroup> = this.stepLocatario.asObservable();

  private stepLocador: Subject<FormGroup> = new Subject();
  formLocador: Observable<FormGroup> = this.stepLocador.asObservable();

  private stepInfoPagamento: Subject<FormGroup> = new Subject();
  formPagamento: Observable<FormGroup> = this.stepInfoPagamento.asObservable();

  objectForm: FormGroup = this._formBuilder.group({

    //atributos dos forms
    produtoGarantia: '',
    objetoGarantia: '',
    titularSubscritor: '',
    locatario: '',
    locador: '',
    formaPagamento: ''

  })
  locatarioFlag: boolean = false;

  constructor(
    private _formBuilder: FormBuilder
  ) {
    this.formProdutoGarantia.subscribe(form =>
      form.valueChanges.subscribe(value => {
        this.objectForm.value.produtoGarantia = value
      })
    )
    this.formObjetoGarantia.subscribe(form =>
      form.valueChanges.subscribe(value => {
        this.objectForm.value.objetoGarantia = value
      })
    )

    this.formTitularSubscritor.subscribe(form =>
      form.valueChanges.subscribe(value => {
        this.objectForm.value.titularSubscritor = value
      })
    )

    this.formLocatario.subscribe(form =>
      form.valueChanges.subscribe(value => {
        this.objectForm.value.locatario = value
      })
    )

    this.formLocador.subscribe(form =>
      form.valueChanges.subscribe(value => {
        this.objectForm.value.locador = value
      })
    )

    this.formPagamento.subscribe(form =>
      form.valueChanges.subscribe(value => {
        this.objectForm.value.objetoFormaPagamento = value
      })
    )

  }

  stepReady(form: FormGroup, desc: any) {
    switch (desc) {
      case 'produto-garantia': return this.stepProdutoGarantia.next(form)
      case 'objeto-garantia': return this.stepObjetoGarantia.next(form)
      case 'titular-subscritor': return this.stepTitularSubscritor.next(form)
      case 'locatario': return this.stepLocatario.next(form)
      case 'locador': return this.stepLocador.next(form)
      case 'info-pagamento': return this.stepInfoPagamento.next(form)
    }
  }

}
